import { jsxs as a, Fragment as d, jsx as m } from "react/jsx-runtime";
import { c as l } from "./index-2QXL0WYc.js";
import "./LoadingSuspense-BdXYIsHy.js";
import "react";
import "./fuzzysort-eoXOpoo6.js";
import "./components/Badge/Badge.js";
import "./components/ButtonGroup/ButtonGroupProvider.js";
import { propagateTestid as o } from "./helpers/utility/propagateTestid.js";
import { GlobalCSSClass as n } from "./enums.js";
import "./components/Card/Card.js";
import "./components/CheckboxGroup/CheckboxGroup.js";
import "./components/Col/Col.js";
import "./components/Expander/Expander.js";
import "./components/Form/FormContext.js";
import "./components/Menu/Menu.js";
import "./components/Menu/MenuProvider.js";
import "./components/Popover/PopoverProvider.js";
import "./components/CheckboxMark/CheckboxMark.types.js";
import "./components/CheckboxMark/CheckboxMark.js";
import "./components/Modal/ModalProvider.js";
import "./components/Panel/Panel.js";
import "./components/Popover/Popover.js";
import "./components/Popover/InputPopover/InputPopover.js";
import "./components/Slideout/SlideoutProvider.js";
import "react-dom";
import "./components/RadioGroup/RadioGroup.js";
import "./components/Text/Text.js";
import "./components/Skeleton/Skeleton.js";
import "./components/SkipLink/SkipLink.js";
import "./components/Stack/Stack.js";
import "./components/Table/TableContext.js";
import "./components/TabSet/Tab/Tab.js";
import "./components/TabSet/TabSet.js";
import "./components/Toggle/Toggle.js";
import "./components/Tooltip/Tooltip.js";
import "./components/ValidationMessage/ValidationMessage.js";
import { IressValidationSummary as c } from "./components/ValidationMessage/ValidationSummary/ValidationSummary.js";
import { getUniqueItemsByKey as f } from "./components/Field/helpers/getUniqueItemsByKey.js";
const v = "ids-field-v5150", h = "ids-field--invalid-v5150", y = "ids-field--label-v5150", b = "ids-field--hidden-label-v5150", S = "ids-field--hint-v5150", u = "ids-field--error-summary-v5150", e = {
  field: v,
  invalid: h,
  label: y,
  hiddenLabel: b,
  hint: S,
  errorSummary: u
}, oi = ({
  error: p,
  errorMessages: i,
  hiddenLabel: s,
  hint: r,
  "data-parent-testid": t
}) => /* @__PURE__ */ a(d, { children: [
  r && /* @__PURE__ */ m(
    "div",
    {
      className: l(e.hint, {
        [n.SROnly]: s
      }),
      "data-testid": o(t, "hint"),
      children: r
    }
  ),
  p,
  i && /* @__PURE__ */ m(
    c,
    {
      className: e.errorSummary,
      messages: f(i, "message"),
      "data-testid": o(t, "error")
    }
  )
] });
export {
  oi as F,
  e as s
};
